<template>
    <li :class="{'active': isActive}" @click="changeStatus"><span><i class="icon-plus"></i>{{category.title}}</span></li>
</template>

<script>
    export default {
        props: {
            'category': Object,
            'isActive': Boolean
        },
        methods: {
            changeStatus() {
                this.$emit('statusChange', this.category.slug);
            }
        }
    }
</script>